import dayjs from 'dayjs';
import Text from '../../../../components/detail/components/Text.component';
import { Box, Stack, Typography } from '@mui/material';
import { StatusBilling, StatusOperationBookingType } from '../../../operations/conf/Data.conf';
import {
  CalendarMonth,
  LocationOn,
} from '@mui/icons-material';
import Modal from '../../../../components/common/Modal.component';
import SimpleTable from '../../../../components/simpleTable/SimpleTable.component';
import { ListAllItemsConf } from '../../../listItemsProvisions/conf/List.conf';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import _ from 'lodash';
import { defaultChipColor } from '../Data.conf';
import RectangleChip from '../../../../components/common/RectangleChip.component';
import { StatusDefault as StatusBooking } from '../../../booking/conf/Data.conf';
import { Fragment } from 'react';

export const DetailConf = {
  initialState: {
    loading: false,
    error: null,
    data: null,
    meta: null,
  },
  fields: [
    {
      type: 'text',
      key: 'attributes.status_operation_booking',
      xs: 12,
      sm: 4,
      md: 4,
      lg: 3,
      xl: 1,
    },
    {
      type: 'text',
      key: 'attributes',
      xs: 12,
      sm: 4,
      md: 4,
      lg: 3,
      xl: 1.5,
    },
    {
      type: 'text',
      label: 'Service Details',
      key: 'attributes.operation_service',
      xs: 12,
      sm: 4,
      md: 4,
      lg: 3,
      xl: 2,
      variant: 'subtitle2',
    },
    {
      type: 'text',
      label: 'CH/BO',
      key: 'attributes.account_type',
      xs: 12,
      sm: 4,
      md: 4,
      lg: 3,
      xl: 1,
      variant: 'subtitle2',
    },
    {
      type: 'text',
      key: 'attributes.requested_date',
      xs: 12,
      sm: 4,
      md: 4,
      lg: 3,
      xl: 1,
    },
    {
      type: 'text',
      key: 'attributes.id_marina.data.attributes.marina',
      xs: 12,
      sm: 4,
      md: 4,
      lg: 3,
      xl: 1,
    },
    {
      type: 'text',
      label: 'Sales Order',
      key: 'attributes.OC_BC_number',
      xs: 12,
      sm: 4,
      md: 4,
      lg: 3,
      xl: 1.5,
      variant: 'subtitle2',
    },
    {
      type: 'text',
      label: 'Purchase Order',
      key: 'attributes.OF_BF_number',
      xs: 12,
      sm: 4,
      md: 4,
      lg: 3,
      xl: 1.5,
      variant: 'subtitle2',
    },
    {
      type: 'text',
      key: 'attributes.status_billing',
      xs: 12,
      sm: 4,
      md: 4,
      lg: 3,
      xl: 1,
    },
    {
      type: 'text',
      key: 'attributes.id_list.data.attributes.id_list_items.data',
    },
  ],
  formatValue: (key, value) => {
    switch (key) {
      case 'attributes.OC_BC_number':
        return (
          <Fragment>
            <Typography
              variant={'subtitle2'}
              textTransform={'capitalize'}
              whiteSpace='nowrap'
              pr={1}
              fontWeight={'bold'}
              color='#446080'
              mr={1}
            >
              <p>
                Sales <br /> Order <br /> Number:
              </p>
            </Typography>
            <Typography color='#446080' variant='subtitle2'>
              {value}
            </Typography>
          </Fragment>
        );
      case 'attributes.OF_BF_number':
        return (
          <Fragment>
            <Typography
              variant={'subtitle2'}
              textTransform={'capitalize'}
              whiteSpace='nowrap'
              pr={1}
              fontWeight={'bold'}
              color='#446080'
            >
              <p>
                Purchase <br /> Order <br /> Number:
              </p>
            </Typography>
            <Typography color='#446080' variant='subtitle2'>
              {value}
            </Typography>
          </Fragment>
        );
      case 'attributes.status_operation_booking':
        const statusInfo =
          _.concat(StatusOperationBookingType, StatusBooking).find(
            (item) => item.id === value
          ) || defaultChipColor;
        return (
          <RectangleChip
            value={value || '-'}
            size='small'
            backgroundColor={statusInfo?.backgroundColor}
            color={statusInfo?.color}
            sx={{
              ml: 1,
              boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
              borderRadius: 1,
            }}
            fontSize='0.75rem'
            fontWeight={600}
            width={'auto'}
          />
        );
      case 'attributes':
        return (
          <RectangleChip
            value={
              value.id_reservation?.data?.attributes?.reservation_type ||
              value.id_service?.data?.attributes?.service ||
              value.id_shipping?.data?.attributes?.id_shipping_type?.data
                ?.attributes?.shipping_type ||
              value.operation_service.toUpperCase()
            }
            size='small'
            sx={{
              boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
              borderRadius: 1,
              backgroundColor: '#009ab6',
              color: 'white',
            }}
            fontSize='0.75rem'
            fontWeight={600}
            width={'auto'}
          />
        );
      case 'attributes.requested_date':
        return (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <CalendarMonth fontSize='small' color='action' />
            <Text
              variant='subtitle2'
              label=''
              value={dayjs(value).format('DD-MM-YYYY') || '-'}
            />
          </Box>
        );
      case 'attributes.id_marina.data.attributes.marina':
        return (
          <Box
            sx={{
              display: 'flex',
              gap: 0.5,
            }}
          >
            <LocationOn
              fontSize='small'
              color='action'
              sx={{ verticalAlign: 'middle', mr: 0.5 }}
            />
            <Text variant='subtitle2' label='' value={value || '-'} />
          </Box>
        );
      case 'attributes.status_billing':
        const statusInfoBilling =
          StatusBilling.find(
            (item) => item.id === value
          ) || defaultChipColor;
        return (
          <RectangleChip
            value={value || '-'}
            size='small'
            backgroundColor={statusInfoBilling?.backgroundColor}
            color={statusInfoBilling?.color}
            sx={{
              ml: 1,
              boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
              borderRadius: 1,
            }}
            fontSize='0.75rem'
            fontWeight={600}
            width={'auto'}
          />
        );
      case 'attributes.id_list.data.attributes.id_list_items.data':
        const productsList = value || [];
        return (
          !_.isEmpty(value) && (
            <Box
              sx={{
                position: 'absolute',
                top: 4,
                right: 4,
                zIndex: 1,
              }}
            >
              <Modal
                label={<ReceiptLongIcon sx={{ color: '#00568d' }} />}
                sx={{
                  color: 'text.primary',
                  cursor: 'pointer',
                  '&:hover': { color: 'primary.main' },
                }}
                width={'80%'}
              >
                <Stack spacing={2}>
                  <Typography
                    variant='h4'
                    sx={{
                      fontWeight: 'bold',
                      alignItems: 'center',
                      display: 'flex',
                    }}
                  >
                    Items List
                  </Typography>
                  <SimpleTable
                    minWidth={900}
                    data={productsList}
                    module={{ list: { conf: ListAllItemsConf } }}
                  />
                </Stack>
              </Modal>
            </Box>
          )
        );
      default:
        return null;
    }
  },
};
